var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"p-4 flex flex-col"},[_c('h1',{staticClass:"text-blue-800 font-bold text-xl"},[_vm._v("URL Click Analytics")]),_c('p',{staticClass:"pb-8 text-sm"},[_vm._v("Coming soon.")])])
}]

export { render, staticRenderFns }